<template>
  <div :id="$style.dream_post_detail">
    <div :class="$style.img">
      <img :src="item.image" alt />
    </div>
    <div :id="$style.message">{{ item.message }}</div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "DreamPostDetail",
  props: {
    item: {
      type: Object
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #dream_post_detail {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: 30px 0px;
    padding: 0px 20px;
    .img {
      width: 250px;
      img {
        width: 100%;
      }
    }
    #message {
      width: 250px;
      min-height: 200px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #707070;
      padding: 20px 30px;
      font-size: 13px;
      text-align: center;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #dream_post_detail {
    display: flex;
    margin: 30px 0px;
    img {
      width: 300px;
    }
    #message {
      width: 600px;
      height: 438px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #707070;
      padding: 0px 40px;
    }
  }
}
</style>


